// Module
var code = "<div class=\"ui-grid-cell-contents u-flexEnd\">\n    <div class=\"u-flex u-flexMiddle\" ng-class=\"{'is-negative-charge' : row.entity.balance < 0}\" ng-bind=\"row.entity.balance | invCurrency: row.entity.currencyCode:null:true\"></div>\n</div>\n";
// Exports
module.exports = code;